import { render, staticRenderFns } from "./recommod-serch.vue?vue&type=template&id=489bda21&scoped=true&"
import script from "./recommod-serch.vue?vue&type=script&lang=js&"
export * from "./recommod-serch.vue?vue&type=script&lang=js&"
import style0 from "./recommod-serch.vue?vue&type=style&index=0&id=489bda21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bda21",
  null
  
)

export default component.exports